class OsDetection {
  isIOS() {
    if (typeof navigator === 'undefined') {
      return false;
    }

    return /iPhone|iPad|iPod/i.test(navigator.userAgent) || /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
  }

  isAndroid() {
    if (typeof navigator === 'undefined') {
      return false;
    }

    return /Android/i.test(navigator.userAgent);
  }
}

export default OsDetection;
